import React, { useEffect, useState } from "react";

//inicio sesión azure
import SignInButton from "../../msal/SignInButton";
import SignInPopup from "../../msal/SignInPopup";

//iconos
import sign_in from "../../assets/icons/sign-in.svg";

//peticiones
import axios from "axios";
import * as constants from "../../global/const";
import { useMsal } from "@azure/msal-react";

const LoginComponent = (props) => {
  const [enterokay, setEnterokay] = useState();
  const { instance } = useMsal();

  const getLogin = () => {
    axios
      .get(constants.GETHOME + "?tipo=1")
      .then((response) => {
        setEnterokay(response.data);
        props.updateLoad(false);
      })
      .catch((err) => {
        props.updateLoad(false);
      });
  };

  useEffect(() => {
    getLogin();
  }, []);

  return (
    <div
      className="enterokay"
      onClick={(e) => SignInPopup(props.updateLoad, instance)}
    >
      {enterokay ? (
        <React.Fragment>
          <div className="section-center">
            <div className="container">
              <svg
                className="login-svg"
                width="51"
                height="38"
                viewBox="0 0 51 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4443 17.4222C14.4443 13.2 14.4443 8.86667 14.4443 4.64445C14.4443 2.53334 15.9999 0.977783 18.111 0.977783C27.7777 0.977783 37.5554 0.977783 47.2221 0.977783C49.4443 0.977783 50.8888 2.53334 50.9999 4.75556C50.9999 14.4222 50.9999 24.0889 50.9999 33.7556C50.9999 35.9778 49.4443 37.5333 47.2221 37.5333C37.5554 37.5333 27.7777 37.5333 18.111 37.5333C15.9999 37.5333 14.4443 35.9778 14.4443 33.8667C14.4443 29.6445 14.4443 25.3111 14.4443 21.0889C23.2221 21.0889 32.111 21.0889 40.8888 21.0889C40.9999 21.2 40.9999 21.3111 41.111 21.4222C40.7777 21.6445 40.3332 21.8667 40.111 22.0889C37.3332 24.8667 34.5554 27.5333 31.8888 30.3111C30.9999 31.3111 30.8888 32.3111 31.6666 33.0889C32.3332 33.8667 33.5554 33.7556 34.4443 32.8667C38.5554 28.8667 42.5554 24.7556 46.6666 20.6445C47.6666 19.6445 47.6666 18.5333 46.6666 17.5333C42.5554 13.4222 38.4443 9.31112 34.3332 5.31112C34.111 5.08889 33.6666 4.86667 33.3332 4.75556C32.5554 4.53334 31.7777 4.75556 31.3332 5.53334C30.8888 6.42223 31.111 7.20001 31.7777 7.86667C34.5554 10.6445 37.3332 13.4222 40.2221 16.3111C40.4443 16.5333 40.7777 16.8667 41.111 17.3111C31.9999 17.4222 23.2221 17.4222 14.4443 17.4222Z"
                  fill="white"
                />
                <path
                  d="M14.4444 21.0889C10.3333 21.0889 6.22222 21.0889 2.11111 21.0889C1.33333 21.0889 0.333333 21.0889 0.111111 20.0889C0 19.5333 -0.111111 18.6444 0.222222 18.2C0.555556 17.7555 1.44444 17.4222 2.11111 17.4222C6.22222 17.3111 10.3333 17.4222 14.4444 17.4222C14.4444 18.6444 14.4444 19.8666 14.4444 21.0889Z"
                  fill="white"
                />
              </svg>
              <span>
                <h1>{enterokay.titulo}</h1>
                <p>{enterokay.descripcion1}</p>
              </span>
            </div>
            <p className="description top-desciption">
              {enterokay.descripcion2}
            </p>
            <div className="section-button">
              {/* <SignInButton updateLoad={props.updateLoad} /> */}
              <button>Ingresa aquí</button>
            </div>
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
};

export default LoginComponent;
